export enum UserType {
  UNVERIFIED = '',
  PENDING = 'pending',
  STUDENT = 'student',
  LANDLORD = 'landlord',
  UNDER_REVIEW = 'under-review',
}
